import { useCallback } from 'react';
import { tabParam } from '../utils/urlParams';
import { useUrlState } from './useUrlState';

// The open tab, kept in the address as ?tab=gaps. The first tab is left out of the address, and a tab
// the person may not open (or one that does not exist) reads as the first.
export function useTabParam<T extends string>(allowed: readonly T[], fallback: T, key = 'tab'): [T, (tab: T) => void] {
  const { params, update } = useUrlState();
  const tab = tabParam(params, allowed, key) ?? fallback;
  const setTab = useCallback((next: T) => update({ [key]: next === fallback ? null : next }), [update, key, fallback]);
  return [tab, setTab];
}
